import { render, staticRenderFns } from "./psychologists.vue?vue&type=template&id=404c6b3c&scoped=true&"
import script from "./psychologists.vue?vue&type=script&lang=js&"
export * from "./psychologists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c6b3c",
  null
  
)

export default component.exports